import { render, staticRenderFns } from "./EditDiscount.vue?vue&type=template&id=b25faa94&scoped=true"
import script from "./EditDiscount.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditDiscount.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EditDiscount.vue?vue&type=style&index=0&id=b25faa94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25faa94",
  null
  
)

export default component.exports